module.exports = __webpack_public_path__ + "static/img/iQOO 13.bd8ab157.png";